module.exports = __webpack_public_path__ + "img/level.0df7cc8b.svg";